import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from '../config'

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch jobs from API
  const fetchJobs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${config.BASE_URL}/jobs`); // adjust your base URL if needed
      if (res.data.success) {
        setJobs(res.data.data.jobs);
        setSelectedJob(res.data.data.jobs[0] || null);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching jobs:", error);
      setJobs([]);
      setSelectedJob(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  // Delete job handler
  const handleDelete = async (jobId) => {
    if (!window.confirm("Are you sure you want to delete this job?")) return;
    try {
      const res = await axios.delete(`${config.BASE_URL}/jobs/${jobId}`);
      if (res.data.success) {
        // remove job from state
        const updatedJobs = jobs.filter((job) => job.id !== jobId);
        setJobs(updatedJobs);
        // reset selected job if it was deleted
        if (selectedJob?.id === jobId) {
          setSelectedJob(updatedJobs[0] || null);
        }
      }
    } catch (error) {
      console.error("Error deleting job:", error);
    }
  };

  if (loading) return <div className="p-8">Loading jobs...</div>;

  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Jobs List</h1>
        <button
          onClick={() => navigate("/dashboard/add-new")}
          className="bg-black text-white px-4 py-2 rounded flex items-center gap-1 hover:bg-gray-800"
        >
          Add New Job <span className="text-xl">+</span>
        </button>
      </div>

      {jobs.length === 0 ? (
        <div className="text-center text-gray-500 mt-20 text-lg">
          Jobs not found
        </div>
      ) : (
        <div className="flex gap-6 bg-white rounded shadow p-4 max-h-[80vh] overflow-hidden">
          {/* Job List - left */}
          <div className="w-1/3 space-y-3 overflow-y-auto pr-2 max-h-[80vh]">
            {jobs.map((job) => (
              <div
                key={job.id}
                className={`p-3 rounded border cursor-pointer transition ${selectedJob?.id === job.id
                    ? "border-gray-700 bg-gray-100"
                    : "border-gray-200 bg-gray-50 hover:bg-gray-100"
                  }`}
                onClick={() => setSelectedJob(job)}
              >
                <h2 className="font-semibold">{job.title}</h2>
                <h2 className="font-semibold">
                  Category:{" "}
                  <span className="text-blue-600 text-sm">{job.category}</span>
                </h2>
                <h5 className="font-semibold">
                  Location:{" "}
                  <span className="text-xs text-black-500">{job.location}</span>
                </h5>
              </div>
            ))}
          </div>

          {/* Job Details - right */}
          {selectedJob && (
            <div className="flex-1 overflow-y-auto max-h-[80vh]">
              {/* Top gray section */}
              <div className="relative h-40 bg-gray-300 rounded-t">
                <h2 className="font-semibold text-lg text-center mb-4 pt-2 pb-2">
                  Job Info
                </h2>

                {/* Image overlapping */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-20 w-48 h-48">
                  <img
                    src={`${config.BASE_URL}uploads/${selectedJob.image}`}
                    alt={selectedJob.title}
                    className="w-full h-full object-cover rounded-lg border shadow-lg"
                  />
                </div>
              </div>

              {/* Content below the image */}
              <div className="pt-24 px-6 space-y-2 text-sm">
                <p>
                  <span className="font-semibold">Name:</span> {selectedJob.name}
                </p>
                <p>
                  <span className="font-semibold">Job title:</span> {selectedJob.title}
                </p>

                <div className="flex flex-wrap gap-4 mt-1 text-sm">
                  <p>
                    <span className="font-semibold text-black">Email:</span>{" "}
                    <span className="text-blue-600">{selectedJob.email}</span>
                  </p>

                  <p>
                    <span className="font-semibold">Category:</span>{" "}
                    {selectedJob.category}
                  </p>
                  <p>
                    <span className="font-semibold">Level:</span> {selectedJob.level}
                  </p>
                </div>

                <p>
                  <span className="font-semibold">Location:</span>{" "}
                  {selectedJob.location}
                </p>

                <div className="mt-4">
                  <h3 className="font-semibold mb-2">Description</h3>
                  <p className="text-gray-700 whitespace-pre-line leading-relaxed">
                    {selectedJob.description}
                  </p>
                </div>

                <div className="flex gap-4 mt-4 mb-5">
                  <button
                    onClick={() => handleDelete(selectedJob.id)}
                    className="flex-1 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                  >
                    Delete
                  </button>
                  <button
                    onClick={() =>
                      navigate("/dashboard/add-new", { state: { job: selectedJob } })
                    }
                    className="flex-1 bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Jobs;
